module.exports = __webpack_public_path__ + "img/rrss1.a0f2d151.jpg";